import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import Tooltip from 'components/ui/Tooltip';
import Create from './Create/Create';
import ChooseCreateType from './Create/ChooseCreateType';
import Edit from './Edit/Edit';
import Table from './Table';
import RenewalTable from './RenewalTable';

import { useContext } from '../Context';

export default function Index() {
  const { dispatch, actions, state } = useContext();

  const [createPlanTemplate, setCreatePlanTemplate] = useState(null);
  const [showChooseCreateType, setShowChooseCreateType] = useState(false);
  const [renewalOriginalPlan, setRenewalOriginalPlan] = useState(null);
  const [editPlan, setEditPlan] = useState(null);
  const [showRenewalTable, setShowRenewalTable] = useState(false);

  const replaceEmpty = (value) => (value == null || value == '' ? 'N/A' : value);

  const startCreate = (plan) => {
    if (renewalOriginalPlan != null) {
      plan.attributes.original_plan_id = renewalOriginalPlan.id;
    }
    setCreatePlanTemplate(plan.attributes);
    actions.setViewMode(dispatch, 'createPlan');
  };

  const startEdit = (plan) => {
    setEditPlan(plan.attributes);
    actions.setViewMode(dispatch, 'editPlan');
  };

  const viewMode = () => {
    actions.setViewMode(dispatch, 'view');
  };

  const showChoosePlanModal = (plan = null) => {
    setRenewalOriginalPlan(plan);
    setShowChooseCreateType(true);
  };

  return (
    <>
      {state.policy && state.policy.id !== '' && (
        <>
          {state.viewMode === 'editPlan' && (
            <Edit plan={editPlan} onCancel={() => viewMode()} />
          )}
          {state.viewMode === 'createPlan' && (
            <Create template={createPlanTemplate} onCancel={() => viewMode()} />
          )}
          {state.viewMode === 'view' && (
            <>
              <div className="ibox-content mt20">
                <h1>Plans</h1>
                <Row>
                  <Col md={12} className="text-right ">
                    <Button
                      onClick={() => {
                        if (!state.policy.attributes.is_lock) {
                          setShowChooseCreateType(true);
                        }
                      }}
                      bsClass={`btn btn-green width-120 ${state.policy.attributes.is_lock ? 'disabled' : ''}`}
                      data-tip={state.policy.attributes.is_lock ? 'Unlock policy first' : null}
                    >
                      Add Plan
                    </Button>
                  </Col>
                </Row>
                <Table startEdit={startEdit} />
              </div>
              <div className="ibox-content mt20">
                <Row>
                  <Col md={8}>
                    <h1>Renewals And Notifications</h1>
                  </Col>
                  <Col md={4} className="text-right ">
                    <Button
                      onClick={() => {
                        setShowRenewalTable(!showRenewalTable);
                      }}
                      bsClass="btn btn-green width-120"
                    >
                      {showRenewalTable ? 'Hide' : 'Show'}
                    </Button>

                  </Col>
                  <Col md={12}>
                    <div className="well">
                      Latest Plan Renewal Date:
                      {' '}
                      {replaceEmpty(state.policy.attributes.renewal_date_formatted)}
                    </div>
                  </Col>
                </Row>
                {showRenewalTable && (
                <RenewalTable
                  showChoosePlanModal={showChoosePlanModal}
                  startCreate={startCreate}
                />
                ) }

                <ChooseCreateType
                  show={showChooseCreateType}
                  onHide={() => setShowChooseCreateType(false)}
                  startCreate={startCreate}
                />
              </div>
            </>
          )}
        </>
      )}
      <Tooltip />
    </>
  );
}
